/* eslint-disable */

import { useEffect, useMemo, useState } from "react";
import ReactTable from 'react-table';
import { BackButton, BadgeComponent, Breadcrumbs, LoaderComponent, PaginationComponent } from "../../components";
import { useDispatch, useSelector } from "react-redux";
import { getAllFileImportAuditLogs } from "../../redux/slices/card-status-file-import-logs-slice";
import moment from "moment";
import { AuthPageContainer, AuthPageHead, ReactTableWrapper, ReactTableWrappers } from "../../styles/global-styles";
import { useLocation } from "react-router";
import { Menus } from "../../constants/menus-constant";
import { providerInstitutionConstant } from "../../constants/user-constants";

const CardStatusFileImportAuditLogs = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    const { user } = useSelector((state) => state.loginUserReducer);

    const { loading, fileImportAuditLogsData, pagination } = useSelector((state) => state.cardStatusFileImportLogsReducer);

    const isProvider = (user?.institution?.id === providerInstitutionConstant?.id) && (user?.superAdmin);

    const MenuList = Menus({ user });

    const { label: PageLabel, icon: PageIcon } = MenuList?.flatMap(i => i?.subMenus)?.filter(i => i?.to === location?.pathname)[0];

    const initialPagination = {
        currentPage: 0,
        pageSize: 20,
    };

    const initialOrderBy = {
        sortColumn: "updatedAt",
        isAsce: false,
    };

    const initialSearch = {
        // id: '',
        // timestamp: '',
        // user: '',
        // action: '',
        // batchName: '',
        // batchId: '',
        // changes: ''
    };

    const initialStates = {
        data: [],
        pagination: initialPagination,
        orderBy: initialOrderBy,
        search: initialSearch,
        selected: null,
        isDropdownOpen: false,
        isModalOpen: false,
        isUpdate: false,
        isView: false,
        isFiltersOpen: false,
    };

    const [states, setStates] = useState(initialStates);

    const defaultParams = {
        pagination: states.pagination,
        orderBy: states.orderBy,
        search: states.search
    };

    const getAllCardStatusData = async (updatedParams) => {
        if (user && updatedParams) {
            try {
                await Promise.all([
                    // dispatch(getApiConfigValues(user)),
                    dispatch(getAllFileImportAuditLogs({ user, ...updatedParams })),
                ]);
            } catch (error) {
                console.error("One or more API calls failed", error);
            }
        };
    };

    const handlePagination = (e) => {
        const params = {
            ...defaultParams,
            pagination: {
                ...defaultParams.pagination,
                currentPage: e
            }
        };
        getAllCardStatusData(params);
    };

    // const handleSelectRow = (row) => {
    //     if (row === states.selected && states.isDropdownOpen) {
    //         setStates((old) => ({ ...old, isDropdownOpen: false, selected: null }));
    //     } else {
    //         setStates((old) => ({ ...old, isDropdownOpen: true, selected: row }));
    //     }
    // };

    const handleCloseDropdown = () => {
        setStates((old) => ({ ...old, isDropdownOpen: false }));
    };

    // const handleModalOpen = (id) => {
    //     setStates((old) => ({ ...old, isModalOpen: true }));
    //     // if (id) {
    //     //     dispatch(getCardStatusByID({ user, id })).then((action) => {
    //     //         if (action?.payload?.status === 201 || action?.payload?.status === 200) {
    //     //             setStates((old) => ({ ...old, isModalOpen: true }));
    //     //         }
    //     //     });
    //     // }
    // };

    // const handleModalClose = () => {
    //     setStates((old) => ({ ...old, isModalOpen: false, selected: null, isUpdate: false, isView: false }));
    //     dispatch(resetSelected());
    // };

    const handleFiltersSubmit = (e, customSearch = null) => {
        if (e) e.preventDefault();
        const searchToUse = customSearch || states.search;
        const params = {
            ...defaultParams,
            search: searchToUse,
            pagination: initialPagination,
        };
        getAllCardStatusData(params);
    };

    const handleTableFilterChange = (key, value, submit = false) => {
        setStates(old => {
            const updatedSearch = { ...old.search, [key]: value || '' };
            if (submit) {
                setTimeout(() => {
                    handleFiltersSubmit(null, updatedSearch);
                }, 0);
            }
            return { ...old, search: updatedSearch };
        });
    };

    // const actions = (id) => {
    //     const actionsList = [
    //         { label: 'View more', action: () => handleModalOpen(id) },
    //     ];

    //     return actionsList;
    // };

    useEffect(() => {
        getAllCardStatusData(defaultParams);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (fileImportAuditLogsData && Array.isArray(fileImportAuditLogsData)) {
            setStates((old) => ({ ...old, data: fileImportAuditLogsData, pagination: pagination }));
        }
    }, [fileImportAuditLogsData, pagination]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!event.target.closest('.action-dropdown')) {
                handleCloseDropdown();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const columns = useMemo(() => [
        {
            accessor: 'id',
            Header: 'Audit ID',
            minWidth: 120,
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="id"
                    value={filter ? filter.value : ''}
                    onChange={e => { onChange(e.target.value); handleTableFilterChange('id', e.target.value); }}
                    onKeyDown={e => { if (e.key === 'Enter') handleTableFilterChange('id', e.target.value, true); }}
                    placeholder="Search by ID"
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
        },
        {
            accessor: 'createdDate',
            Header: 'Timestamp',
            minWidth: 160,
            Cell: row => row?.original?.createdDate ? moment(row?.original?.createdDate).format('lll') : '',
            Filter: ({ filter, onChange }) => (
                <input
                    type="date"
                    name="timestamp"
                    value={filter ? filter.value : ''}
                    onChange={(e) => {
                        const value = e.target.value;
                        onChange(value);
                        handleTableFilterChange('timestamp', value, true);
                    }}
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
        },
        {
            accessor: 'createdBy',
            Header: 'User',
            minWidth: 160,
            sortable: false,
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="user"
                    value={filter ? filter.value : ''}
                    onChange={e => { onChange(e.target.value); handleTableFilterChange('user', e.target.value); }}
                    onKeyDown={e => { if (e.key === 'Enter') handleTableFilterChange('user', e.target.value, true); }}
                    placeholder="Search by User "
                    style={{ width: '100%' }}
                />
            ),
        },
        {
            accessor: 'action',
            Header: 'Action',
            minWidth: 180,
            Cell: (row) => {
                const status = row?.original?.action?.toLowerCase();
                let type = 'default';
                let outline = false;
                return <BadgeComponent label={status} type={type} outline={outline} />;
            },
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="action"
                    value={filter ? filter.value : ''}
                    onChange={e => { onChange(e.target.value); handleTableFilterChange('action', e.target.value); }}
                    onKeyDown={e => { if (e.key === 'Enter') handleTableFilterChange('action', e.target.value, true); }}
                    placeholder="Search by Action"
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
        },
        {
            accessor: 'batchName',
            Header: 'Entity',
            minWidth: 160,
            sortable: false,
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="batchName"
                    value={filter ? filter.value : ''}
                    onChange={e => { onChange(e.target.value); handleTableFilterChange('batchName', e.target.value); }}
                    onKeyDown={e => { if (e.key === 'Enter') handleTableFilterChange('batchName', e.target.value, true); }}
                    placeholder="Search by Entity"
                    style={{ width: '100%' }}
                />
            ),
            sortable: false,
        },
        {
            accessor: 'cardRegistryId',
            Header: 'Entity ID',
            minWidth: 120,
            Cell: row => row?.original?.cardRegistryId,
            sortable: false,
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="batchId"
                    value={filter ? filter.value : ''}
                    onChange={e => { onChange(e.target.value); handleTableFilterChange('batchId', e.target.value); }}
                    onKeyDown={e => { if (e.key === 'Enter') handleTableFilterChange('batchId', e.target.value, true); }}
                    placeholder="Search by ID"
                    style={{ width: '100%' }}
                />
            ),
        },
        {
            accessor: 'changes',
            Header: 'Changes',
            minWidth: 260,
            align: 'left',
            Cell: row => row?.original?.changes,
            sortable: false,
            Filter: ({ filter, onChange }) => (
                <input
                    type="text"
                    name="changes"
                    value={filter ? filter.value : ''}
                    onChange={e => { onChange(e.target.value); handleTableFilterChange('changes', e.target.value); }}
                    onKeyDown={e => { if (e.key === 'Enter') handleTableFilterChange('changes', e.target.value, true); }}
                    placeholder="Search by Changes"
                    style={{ width: '100%' }}
                />
            ),
        },
        // {
        //     accessor: 'ipAddress',
        //     Header: 'IP Address',
        //     minWidth: 150,
        //     Cell: row => row?.original?.ipAddress,
        //     sortable: false,
        //     Filter: ({ filter, onChange }) => (
        //         <input
        //             type="text"
        //             name="ipAddress"
        //             value={filter ? filter.value : ''}
        //             onChange={e => { onChange(e.target.value); handleTableFilterChange('ipAddress', e.target.value); }}
        //             onKeyDown={e => { if (e.key === 'Enter') handleTableFilterChange('ipAddress', e.target.value, true); }}
        //             placeholder="Search by IP Address"
        //             style={{ width: '100%' }}
        //         />
        //     ),
        // }

    ], [states.isDropdownOpen, states.selected]); // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <AuthPageContainer $heightfull>
            {/* BACK BUTTON */}
            <BackButton />
            {/* PAGE HEAD */}
            <AuthPageHead>
                <div className="left">
                    <PageIcon className="page-icon" />
                    <h1>Audit Logs</h1>
                    <Breadcrumbs
                        items={[
                            { label: "Home", to: "/app/home" },
                            { label: PageLabel }
                        ]}
                        separator="›"
                        activeLastBreadcrumb={false}
                        size="small"
                        color={'var(--text-color-secondary)'}
                    />
                </div>
            </AuthPageHead>

            {/* LOADING STATE */}
            {
                loading &&
                <LoaderComponent />
            }

            {/* PAGE CONTENT */}
            {
                // !loading && states.data && states.data.length > 0 &&
                // <Fragment>
                //     <TableComponent rows={states.data} columns={columns} icon={HistorySvg} />
                //     <PaginationComponent data={states.pagination} handleChange={(e) => handlePagination(e)} />
                // </Fragment>
                <>
                    <PaginationComponent
                        page={states?.pagination?.currentPage}
                        pages={states?.pagination?.totalPages || 1}
                        onPageChange={(e) => handlePagination(e)}
                        canPrevious={states?.pagination?.currentPage > 0}
                        canNext={states?.pagination?.currentPage < (states?.pagination?.totalPages - 1)}
                    />
                    <ReactTableWrapper className="box-shadow custom-scrollbar">
                        <ReactTableWrappers>
                            <ReactTable
                                manual
                                loading={loading}
                                data={states?.data}
                                columns={columns}
                                page={states?.pagination?.currentPage || 0}
                                pageSize={states?.pagination?.pageSize || 20}
                                pages={states?.pagination?.totalPages || 1}
                                filterable={true}
                                showPagination={false}
                                showPageJump={true}
                                showPageSizeOptions={false}
                                showPaginationTop={true}
                                showPaginationBottom={false}
                                onPageChange={(e) => handlePagination(e)}
                                minRows={0}
                            />
                        </ReactTableWrappers>
                    </ReactTableWrapper>
                </>
            }

            {/* MODAL */}
            {/* {
                states.isModalOpen &&
                <ViewCardStatusFileImportLogsModal
                    data={states.selected}
                    close={handleModalClose}
                    label="File Imports Details"
                    slide
                />
            } */}
        </AuthPageContainer>
    );
};

export default CardStatusFileImportAuditLogs;